<template>
    <div class="DocumentEditor">
        
        <b-modal ref="component-modal" :title="ModalTitle" size="lg" hide-footer>
            <b-container>
                <b-row>
                    <b-col>
                        <div v-if="Feedback.length > 0">
                            <p class="bold">PRIOR FEEDBACK</p>
                            <p v-for="feedback in Feedback" class="orange-bg">
                                <span class="bold">Feedback by {{ feedback.Reviewer }} on {{ feedback.ReviewedAt }}:</span> {{ feedback.Comments }}
                            </p>
                        </div>
                    </b-col>
                </b-row>
                <PDFViewer :source-file-id="SourceFileId" :document-name="DocumentName" :grouped-documents="GroupedDocuments"/>

                <b-row class="modal-btn-row">

                    <div class="modal-btn-row-div">

                        <b-button size="md" variant="secondary" @click="Cancel()">
                            CLOSE
                        </b-button>
                        <b-button v-if="Reviewing" size="md" variant="success" @click="ShowApprove()">
                            <font-awesome-icon :icon="['fa', 'signature']" />
                            APPROVE
                        </b-button>
                        <b-button v-if="Reviewing" size="md" variant="danger" @click="ShowReturn()">
                            <font-awesome-icon :icon="['fas', 'ban']" />
                            RETURN
                        </b-button>
                    </div>
                </b-row>
                <div v-if="ViewerType == 'Single' && DocumentId && AddendaAllowed">
                    <b-row v-if="Addenda.length > 0">
                        <b-col>
                            <h4 class="bold underline">Addenda:</h4>
                            <div v-for="addendum in Addenda" style="margin-top:5px;">
                                <p class="bold">{{ formatDate(addendum.NoteDate) }} by {{ addendum.AuthorName }} <span v-if="addendum.UserCanDelete" @click="DeleteAddendum(addendum.Id)" class="red pointer"><font-awesome-icon :icon="['fa', 'trash-alt']" /></span>:</p>
                                <p>{{ addendum.Note }}</p>
                            </div>
                        </b-col>
                    </b-row>
                    <b-row>
                        <b-col>
                            <div class="form-group">
                                <label class="bold">Add Addendum to Document:</label>
                                <textarea rows="5" type="password" v-model="NewAddendumNote" class="form-control" />
                                <b-button @click="AddAddendum()" size="md" class="form-control" style="margin-top:5px;">ADD ADDENDUM</b-button>
                            </div>
                        </b-col>
                    </b-row>
                </div>
                
            </b-container>
            <DigitalPasswordSignature ref="signature-modal-component" modal-title="Digitally Approve Document" v-on:passwordentered="ApproveDocument" />
            <DigitalRejection ref="rejection-modal-component" v-on:commentsentered="ReturnDocument" />
        </b-modal>

    </div>

</template>

<script>
    //import icons
    import { library } from '@fortawesome/fontawesome-svg-core';
    import { faBan } from '@fortawesome/free-solid-svg-icons';
    library.add(faBan);
    import { faSignature } from '@fortawesome/free-solid-svg-icons';
    library.add(faSignature);

    import PDFViewer from "./PDFViewer.vue";
    import DigitalPasswordSignature from "./DigitalPasswordSignature.vue";
    import DigitalRejection from "./DigitalRejection.vue";

    import { EventBus } from '../../../services/event-bus.js';

    export default {
        props: [
            "Reviewing"
        ],
        data: function () {
            return {
                DocumentId: "",
                SourceFileId: "",
                ModalTitle: "",
                DocumentName: "",
                GroupedDocuments: null,
                Feedback: [],
                Addenda: [],
                AddendaAllowed: false,
                ViewerType: "",
                NewAddendumNote: null,
            }
        },
        methods: {
            ShowViewerModal: function (pdfFileID, formLabel, documentName, documentID = null) {
                this.Feedback = [];
                this.SourceFileId = pdfFileID;
                this.ModalTitle = formLabel;
                this.DocumentName = documentName;
                this.DocumentId = documentID;
                this.ViewerType = "Single";
                this.NewAddendumNote = null;
                this.$set(this, 'GroupedDocuments', null);
                if (documentID && this.Reviewing == true) {
                    this.GetFeedback();
                }
                if (documentID) {
                    this.GetAddenda();
                }
                
                this.$refs['component-modal'].show();
            },
            ShowViewerModalWithComboDocs: function (docIDs) {
                this.Feedback = [];
                this.ModalTitle = "Document Group";
                this.ViewerType = "Group";
                this.NewAddendumNote = null;
                this.$set(this, 'GroupedDocuments', { DocIDs: docIDs })
                this.$refs['component-modal'].show();
            },
            ShowViewerModalWithGroupedDocs: function (ChartID, ChapterName, SectionName) {
                this.Feedback = [];
                this.ViewerType = "Group";
                this.NewAddendumNote = null;
                this.ModalTitle = "Document Group: " + ChapterName  + (SectionName == null ? "" :", " + SectionName);
                this.$set(this, 'GroupedDocuments', {ChartID: ChartID, ChapterName: ChapterName, SectionName: SectionName})
                this.$refs['component-modal'].show();
            },
            Cancel: function () {
                this.$refs['component-modal'].hide();
            },
            ShowApprove: function () {
                this.$refs['signature-modal-component'].ShowModal();
            },
            ShowReturn: function () {
                this.$refs['rejection-modal-component'].ShowModal();
            },
            ApproveDocument(password) {
                this.DigitallyReviewDocument(this.DocumentId, "Approved", null, password);
            },
            ReturnDocument(comments) {
                this.DigitallyReviewDocument(this.DocumentId, "Rejected", comments, null);
            },
            DigitallyReviewDocument(documentID, reviewerDecision, comments, password) {
                this.$MasterAPI.ExecuteRequest("POST", "Documents/ReviewDocumentDigitally", { DocumentID: documentID, ReviewerDecision: reviewerDecision, Comments: comments, Password: password }, this.DigitallyReviewDocumentSuccess, () => { }, true);
            },
            DigitallyReviewDocumentSuccess(response) {
                EventBus.$emit('drafts-updated', this.ChartRecordId);
                            
                //TODO: send eventbus update for specific chart record update
                this.$refs['component-modal'].hide();
            },
            GetFeedback() {
                this.$MasterAPI.ExecuteRequest("Get", "Documents/GetFeedback", { DocumentID: this.DocumentId }, this.GetFeedbackSuccess, () => { }, false);
            },
            GetFeedbackSuccess(response) {
                this.Feedback = response.data.data;
            },
            formatDate(value, fmt = 'MM/DD/YYYY') {
                return (value == null)
                    ? ''
                    : moment(value, 'YYYY-MM-DD').format(fmt)
            },

            //ADDENDA
            GetAddenda() {
                this.$MasterAPI.ExecuteRequest("GET", "DocumentAddenda", { DocumentID: this.DocumentId }, this.GetAddendaSuccess, () => { }, false);
            },
            GetAddendaSuccess(response) {
                
                this.Addenda = response.data.data.ListDetail;
                this.AddendaAllowed = response.data.data.FormAddendaAllowed;
            },
            AddAddendum() {
                this.$MasterAPI.ExecuteRequest("POST", "DocumentAddenda", { DocumentID: this.DocumentId, Note: this.NewAddendumNote }, this.AddAddendumSuccess, () => { }, true);
            },
            AddAddendumSuccess(response) {
                this.NewAddendumNote = null;
                EventBus.$emit('pdf-update-needed','addendum-change');
                this.GetAddenda();
            },
            DeleteAddendum(id) {
                this.$MasterAPI.ExecuteRequest("DELETE", "DocumentAddenda/" + id, {  }, this.AddAddendumSuccess, () => { }, true);
            }
            
        },
        components: {
            PDFViewer,
            DigitalRejection,
            DigitalPasswordSignature
        },
        computed: {
            
        },
        mounted: function () {
            
        }
    }
</script>

<style scoped>

</style>